var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 2.13a8.236 8.236 0 0 1-2.474.716A4.518 4.518 0 0 0 20.421.333a8.348 8.348 0 0 1-2.738 1.101A4.197 4.197 0 0 0 14.539 0c-2.378 0-4.307 2.035-4.307 4.544 0 .356.037.702.11 1.035-3.58-.19-6.754-1.997-8.88-4.75a4.73 4.73 0 0 0-.583 2.287c0 1.576.76 2.967 1.917 3.782a4.142 4.142 0 0 1-1.953-.566v.055c0 2.203 1.485 4.04 3.458 4.456-.362.107-.742.16-1.136.16-.277 0-.548-.027-.81-.08.548 1.804 2.138 3.118 4.024 3.153-1.474 1.22-3.333 1.947-5.351 1.947-.348 0-.691-.021-1.028-.063A11.759 11.759 0 0 0 6.604 18c7.926 0 12.259-6.923 12.259-12.928 0-.198-.004-.396-.011-.59A8.996 8.996 0 0 0 21 2.132"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.36515db2.svg";
export { ForwardRef as ReactComponent };